import React from 'react';

const UnlockedSvg = () => {
    return (
<svg version="1.1" id="Open" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" fill="#0CD428" viewBox="0 0 30 30" style={{ enableBackground: 'new 0 0 30 30' }} xmlSpace="preserve">
  <path
    className="st0"
    d="M24.6,12.7H11V8c0-2.2,1.8-4,4-4c1.4,0,2.7,0.8,3.4,1.9h3.5c-0.9-3-3.6-5.2-6.9-5.2C11,0.8,7.8,4,7.8,8v4.7H5.4
    c-0.8,0-1.4,0.6-1.4,1.4v13.7c0,0.8,0.6,1.4,1.4,1.4h19.1c0.8,0,1.4-0.6,1.4-1.4V14.1C26,13.3,25.3,12.7,24.6,12.7z"
  />
</svg>
    );
};

export default UnlockedSvg;
